import React from "react"

export default function Story({ path, id }) {
  return (
    <iframe
      title={id}
      src={path}
      style={{
        width: 320,
        height: 480,
        border: 0
        // marginLeft: "-8px",
        // marginTop: "15px",
      }}
      layout="fixed"
      name="ad-creative-frame"
      sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
    />
  )
}
